import zohoCrmIcon from "../../src/assets/images/crm.svg";

export const PROVIDER_KEYS = {
  ZOHO_CRM: "zoho_crm",
};

export const ZOHO_NAMESPACE = process.env.NODE_ENV === "production" ? "dochipo" : "dochipodev";

export const PROVIDERS = {
  [PROVIDER_KEYS.ZOHO_CRM]: {
    title: "Zoho CRM",
    urlSlug: "zoho-crm",
    authPath: "/api/crm/zoho/auth",
    recordPath: "zoho-crm/Deals/records",
    icon: zohoCrmIcon,
    modules: ["Deals"],
    providerVariables: {
      apiKey: `${ZOHO_NAMESPACE}__API_Key`,
      installationId: `${ZOHO_NAMESPACE}__Installation_Id`,
    },
    crmUrlModules: {
      Deals: "Potentials",
    },
    urlValidRegex: {
      pathPattern : "^\\/crm\\/org\\d+\\/tab\\/Potentials\\/\\d+$"
    }
  },
};

export const ENABLE_THIRD_PARTY_INTEGRATION_MODAL_CONTENT = {
  [PROVIDER_KEYS.ZOHO_CRM]: [
    {
      type: "enable_integration",
      modalHeader: "Enable Integration",
      modalBody: "Enable the Zoho CRM integration first to use it as an external data source for proposal creation.",
      modalButton: "Enable Integration",
    },
    {
      type: "only_admin_enable_integration",
      modalHeader: "Enable Integration",
      modalBody: "Enable the Zoho CRM integration first to use it as an external data source for proposal creation.",
      modalButton: "Only Admin can enable",
      disabled: true,
    },
    {
      type: "authorize_dochipo",
      modalHeader: "Authorize",
      modalBody: "Authorize DocHipo to access your Zoho CRM data and select records for your proposals.",
      modalButton: "Authorize DocHipo",
    },
    {
      type: "user_exists",
      modalHeader: "User Already Linked",
      modalBody:
        "This Zoho CRM user is already linked to a DocHipo account. If this is incorrect, please contact your admin. The current user must disable their integration before you can connect.",
    },
    {
      type: "organization_mismatch",
      modalHeader: "Zoho CRM Organization Mismatch",
      modalBody:
        "Your Zoho CRM account belongs to a different organization than the one connected to this DocHipo company account. Please connect using a user account from the same Zoho CRM organization.",
    },
    {
      type: "admin_required",
      modalHeader: "Super Admin Access Required",
      modalBody:
        "You need Super Admin access in Zoho CRM to enable this integration. Please contact your Zoho CRM Super Admin to proceed.",
    },
  ],
};

export const UNAUTHORIZED_ACCESS = "You don’t have permission to access this record";

export const MESSAGE_DISPLAY_TIME = 3000; // 3sec
